export interface GameConfig {
  name: string;
  displayName: string;
  version: string;
  orientation: 'portrait' | 'landscape' | 'any';
  minAspect: number;
  maxAspect: number;
}

const gameConfig: GameConfig = {
  name: 'fruit-merge-2d',
  displayName: 'Fruit Game',
  version: '0.1.0',
  orientation: 'portrait',
  minAspect: 9 / 16,
  maxAspect: 3 / 4,
};

export default gameConfig;
